export default "__VITE_ASSET__PuHspUVN__"